



























import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'MStoreSimpleTable',
  props: {
    items: {
      required: true,
      type: Array as PropType<Array<Record<string, any>>>
    },
    fields: {
      required: true,
      type: Array as PropType<Array<{ key: string; description: string }>>
    },
    small: {
      type: Boolean,
      default: true
    },
    primaryKey: {
      required: true,
      type: String
    },
    selectable: {
      type: Boolean,
      default: false
    },
    selectedItems: {
      type: Array,
      required: false
    },
    emptyText: {
      type: String,
      default: 'There are no records to show'
    },
    showActions: {
      type: Boolean,
      default: false
    },
    selectedItem: {
      required: false
    }
  },
  computed: {
    allItemsSelected(this: any) {
      if (!this.items.length) {
        return false;
      }

      const allItemIds = (this.items as Array<Record<string, any>>).map((x) => x[this.primaryKey]);
      const selectedItems = this.selectedItems as any[];
      return allItemIds?.every((item) => selectedItems.includes(item)) ?? false;
    }
  }
});
